/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var rowDefaultProps = {
  align: "top",
  gutter: 0,
  justify: "start",
  tag: "div"
};
var colDefaultProps = {
  offset: 0,
  order: 0,
  pull: 0,
  push: 0,
  tag: "div"
};

export { colDefaultProps, rowDefaultProps };
//# sourceMappingURL=defaultProps.js.map
